import get from 'lodash.get';

const buildAccordionDtmData = (linkObj = {}) => {
  const accordionData = {
    dtmSections: get(linkObj, 'dtm.sections') || [],
    actionTrackingAttr: get(linkObj, 'actionTracking.attribute') || '',
    dtmEventAsset: get(linkObj, 'dtm.eventAsset') || ''
  };

  const useTextAsAction = text =>
    ['expand', 'collapse'].indexOf(String(text).toLowerCase()) > -1;

  const benefitsAnalyticsData = accordionData.dtmSections.map(
    ({ keywords = [], text = '' }) => {
      const dtmVal = useTextAsAction(text)
        ? {
            ...linkObj.dtm,
            eventAction: text
          }
        : {
            ...linkObj.dtm,
            eventAsset: `${accordionData.dtmEventAsset}${text}`
          };

      const actonTrackVal = linkObj.actionTracking
        ? {
            ...linkObj.actionTracking,
            attribute: `${accordionData.actionTrackingAttr}${text ? `_${text}` : ''}`
          }
        : {};

      return {
        keywords,
        actionTracking: actonTrackVal,
        dtm: dtmVal
      };
    }
  );

  return {
    ...benefitsAnalyticsData
  };
};

export default buildAccordionDtmData;
